/* eslint-disable react/prop-types */

import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import FilterableDashboard from './FilterableDashboard';

// The SectionComponent handles a single dashboard section
const SectionComponent = ({ keyId, stateId, onDistrictChange, seasonData }) => {
  // No need for local state here as we're now fully controlled by the parent

  // Pass the district change up to the parent
  const handleDistrictChange = districtId => {
    if (onDistrictChange && typeof onDistrictChange === 'function') {
      onDistrictChange(districtId);
    }
  };

  return (
    <Row className="mb-4">
      <Col lg={12}>
        <FilterableDashboard
          keyId={keyId}
          stateId={stateId}
          onDistrictChange={handleDistrictChange}
          seasonData={seasonData}
        />
      </Col>
    </Row>
  );
};

export default SectionComponent;
